import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

const ShareModalDownloadReasons = ({
  allowDownload,
  downloadReasons,
  userCanDownload,
  hasRestrictedFiles,
  handleChange,
}) => {
  const intl = useIntl();

  if (!userCanDownload || hasRestrictedFiles) {
    return null;
  }

  return (
    <div className={classnames('share-download-reasons share-setting', { error: (!userCanDownload && hasRestrictedFiles) })}>
      {userCanDownload && (
        <Label
          for="inpDownloadReasons"
          className={classnames('switch', {
            disabled: !canUserManageShare() || !allowDownload,
          })}
        >
          <span>
            {intl.formatMessage({ defaultMessage: 'Download reason' })}
          </span>
          <div className="share-setting-switch-wrapper">
            <UpgradePlanButton feature="download-reasons" simple={true} />
            {!allowDownload && (
              <HelpIcon id="share-download-reasons-disabled" permanent={true}>
                {intl.formatMessage({ defaultMessage: 'Enable downloading to require reasons' })}
              </HelpIcon>
            )}
            {userHasFeature('share-download-reasons') && (
              <div className="switch-control input-inner">
                <Input
                  type="checkbox"
                  name="download-reasons"
                  id="inpDownloadReasons"
                  value={true}
                  checked={downloadReasons}
                  onChange={handleChange}
                  disabled={!canUserManageShare() || !allowDownload}
                />
                <i />
              </div>
            )}
          </div>
        </Label>
      )}
    </div>
  );
};

ShareModalDownloadReasons.propTypes = {
  allowDownload: PropTypes.bool.isRequired,
  downloadReasons: PropTypes.bool.isRequired,
  userCanDownload: PropTypes.bool.isRequired,
  hasRestrictedFiles: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalDownloadReasons;
